import { logInfo } from './logging';

export interface IUrlVars {
  [key: string]: any;
}

const getUrlVars = (): IUrlVars => {
  const results: IUrlVars = {};
  const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  logInfo('hashes', { context: hashes });
  for (const item of hashes) {
    const hash = item.split('=');
    // vars.push(hash[0]);
    results[hash[0]] = hash[1];
  }
  return results;
};

export default getUrlVars;
